module.exports = __webpack_public_path__ + "static/img/Brad-Fittler.f8d5287.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Brad-Fittler.jpg
// module id = BzO0
// module chunks = 0